// The game sandbox origin for a repo: g-<first 16 hex of SHA-256("owner/repo" lowercased)>.<host domain>.
import { sha256Hex } from './hash.ts';

export async function sandboxHash(owner: string, repo: string): Promise<string> {
  return (await sha256Hex(`${owner}/${repo}`.toLowerCase())).slice(0, 16);
}

/** Build the sandbox origin from the host's own location (same scheme and port). */
export async function sandboxOrigin(
  loc: { protocol: string; hostname: string; port: string },
  owner: string,
  repo: string,
): Promise<string> {
  const hash = await sandboxHash(owner, repo);
  return `${loc.protocol}//g-${hash}.${loc.hostname}${loc.port ? ':' + loc.port : ''}`;
}
